<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $t('message.add') }} {{ $tc('message.ultrasounds', 1) }}
                    </h3>
                </div>
            </div>

            <div class="card-body">
                <b-form @reset="onReset" v-if="show">
                    <b-container>

                        <b-row>

                            <b-col sm="12">
                                <span  class="obligatoire">*</span>
                                <b-form-group
                                        id="single-group"
                                        :label="$t('message.typeOfUltrasound')"
                                        label-for="single"
                                >
                                    <select id="single" v-model="$v.form.type.$model"
                                            @change="clearErrorField('type')"
                                            required
                                            class="form-control is-invalid retirerBordure"
                                    >
                                        <option data-placeholder="true"></option>
                                        <option v-for="item in mTypeOfUltrasound" :key="item.id" :value="item.value">
                                            {{ item.text }}
                                        </option>
                                    </select>
                                    <b-form-invalid-feedback v-if="$v.form.type.$error">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                    <span v-if="errorshasField('type')" style="color:red">
                                    {{getErrorsField('type')}}
                                    </span>
                                </b-form-group>
                            </b-col>
                            <b-col sm="12">
                                <b-form-group
                                        id="ddr-group"
                                        :label="$t('message.ddr')"
                                        label-for="ddr">
                                    <b-form-input
                                            id="ddr"
                                            v-model="$v.form.ddr.$model"
                                            :state="$v.form.ddr.$dirty ? !$v.form.ddr.$error : null"
                                            type="date"
                                            required
                                            @click="clearErrorField('ddr')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback>
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                    <span v-if="errorshasField('ddr')" style="color:red">
                                    {{getErrorsField('ddr')}}
                                    </span>
                                </b-form-group>

                            </b-col>

                        </b-row>

                        <b-row>

                            <b-col sm="12">

                                <b-form-group
                                        id="dpa-group"
                                        :label="$t('message.dpa')"
                                        label-for="dpa">
                                    <b-form-input
                                            id="dpa"
                                            v-model="$v.form.dpa.$model"
                                            :state="$v.form.dpa.$dirty ? !$v.form.dpa.$error : null"
                                            type="date"
                                            required
                                            disabled
                                            @click="clearErrorField('dpa')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback>
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                    <span v-if="errorshasField('dpa')" style="color:red">
                                    {{getErrorsField('dpa')}}
                                    </span>
                                </b-form-group>
                            </b-col>
                            <b-col sm="12">
                                <b-form-group
                                        id="week-group"
                                        :label="$t('message.amenorrheaWeek')"
                                        label-for="week"
                                        description=""
                                >
                                    <b-form-input
                                            id="week"
                                            v-model="$v.form.semaine_amenorrhee.$model"
                                            :state="$v.form.semaine_amenorrhee.$dirty ? !$v.form.semaine_amenorrhee.$error : null"
                                            type="number"
                                            required
                                            placeholder=""
                                            @click="clearErrorField('semaine_amenorrhee')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback>
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                    <span v-if="errorshasField('semaine_amenorrhee')" style="color:red">
                                    {{getErrorsField('semaine_amenorrhee')}}
                                    </span>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <b-row>

                            <b-col sm="12">
                                <b-form-group
                                        id="biometrie-group"
                                        :label="$t('message.biometric')"
                                        label-for="biometrie"
                                >
                                    <b-form-textarea
                                            id="biometrie"
                                            v-model="$v.form.biometrie.$model"
                                            :state="$v.form.biometrie.$dirty ? !(errorshasField('biometrie') || $v.form.biometrie.$error) : null"
                                            placeholder=""
                                            @focus="clearErrorField('biometrie')"
                                    ></b-form-textarea>

                                    <b-form-invalid-feedback v-if="errorshasField('biometrie')">
                                        {{ getErrorsField('biometrie') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>

                            <b-col sm="12">
                                <b-form-group
                                        id="annexe-group"
                                        :label="$t('message.annex')"
                                        label-for="annexe"
                                >
                                    <b-form-textarea
                                            id="annexe"
                                            v-model="$v.form.annexe.$model"
                                            :state="$v.form.annexe.$dirty ? !(errorshasField('annexe') || $v.form.annexe.$error) : null"
                                            placeholder=""
                                            @focus="clearErrorField('annexe')"
                                    ></b-form-textarea>

                                    <b-form-invalid-feedback v-if="errorshasField('annexe')">
                                        {{ getErrorsField('annexe') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>

                            </b-col>

                            <b-col sm="12">

                                <b-form-group
                                        id="description-group"
                                        :label="$t('message.description')"
                                        label-for="description"
                                >
                                    <b-form-textarea
                                            id="annexe"
                                            v-model="$v.form.description.$model"
                                            :state="$v.form.description.$dirty ? !(errorshasField('description') || $v.form.description.$error) : null"
                                            placeholder=""
                                            @focus="clearErrorField('description')"
                                    ></b-form-textarea>

                                    <b-form-invalid-feedback v-if="errorshasField('description')">
                                        {{ getErrorsField('description') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>

                            </b-col>

                        </b-row>
                    </b-container>
                    <b-container>
                        <b-row class="justify-content-sm-center" v-if="can">
                            <b-button @click="onSubmit" variant="primary">
                                {{ $t('message.save') }}
                            </b-button>
                        </b-row>
                    </b-container>

                </b-form>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { required } from 'vuelidate/lib/validators';
    import SlimSelect from 'slim-select';
    import _ from 'lodash';
    import moment from 'moment';



    export default {
        name: "AddUltrasound",

        computed: {
            ...mapGetters(["obstetricConsultation",'errors', "hasAdminRole", "hasMedecinControleRole", "hasPraticienRole","hasAssistante"]),

            can: function (){
                if (this.hasAdminRole){
                    return true;
                }else{
                    return this.hasMedecinControleRole || this.hasPraticienRole || this.hasAssistante;
                }
            },

            consultation: function() {
                return this.obstetricConsultation;
            },


            mTypeOfUltrasound: function() {
                let sArray = [
                    {text:'1er trimestre' ,value:'1er trimestre',id:0},
                    {text:'2eme trimestre' ,value:'2eme trimestre',id:1},
                    {text:'3eme trimestre' ,value:'3eme trimesstre',id:2},
                    {text:'Autre' ,value:'Autre',id:3},
                ];
                return sArray;
            },
        },

        data() {
            return {
                consultation_id: this.$route.params.consultation,
                form: {
                    type: '',
                    ddr:'',
                    dpa: '',
                    semaine_amenorrhee: '',
                    biometrie: '',
                    annexe: '',
                    description: ''
                },
                show: true
            }
        },

        watch:{
            consultation:function (newValue,oldValue) {
            this.form.ddr = oldValue.ddr ;
            this.form.semaine_amenorrhee = Math.trunc(moment.duration((moment().toDate() - moment(newValue.ddr).toDate())).asWeeks());
            },

            'form.ddr':function(newValue, oldValue){
                this.form.dpa = moment(newValue).add(40,'weeks').format('YYYY-MM-DD');
                this.form.semaine_amenorrhee = Math.trunc(moment.duration((moment().toDate() - moment(newValue).toDate())).asWeeks());
            }
        },

        methods: {
            getConsultation() {
                let args = {
                    consultation: this.consultation_id
                };

                this.$store.dispatch("getObstetricConsultation", { args });
            },

            onSubmit: function(evt) {
                evt.preventDefault();

                this.$v.$touch();

                if(!this.$v.$invalid) {
                    let args = {
                        consultation_obstetrique_id: this.consultation.id,
                        type: this.form.type,
                        ddr: this.form.ddr,
                        dpa: this.form.dpa,
                        biometrie: this.form.biometrie,
                        annexe: this.form.annexe,
                        description: this.form.description,
                        semaine_amenorrhee: this.form.semaine_amenorrhee
                    };

                    let successMessage = this.$i18n.t('message.ultrasoundCreated');
                    let errorMessages = {
                        generic: this.$i18n.t('message.genericError'),
                        error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                    };

                    this.$store.dispatch('createUltrasound', { args, errorMessages, successMessage });
                }
            },

            onReset: function(evt) {
                evt.preventDefault();

                // Reset our form values
                this.form.type = '';
                this.form.ddr = '';
                this.form.dpa = '';
                this.form.semaine_amenorrhee = '';

                // Trick to reset/clear native browser form validation state
                this.show = false;

                this.$nextTick(() => {
                    this.show = true;
                });
            },
            getErrorsField(field){
                if (this.errorshasField(field)){
                    return this.errors[field][0];
                }else{
                    return  '';
                }
            },
            errorshasField(field){
                return this.errors ? this.errors.hasOwnProperty(field) : false;
            },
            clearErrorField(field){
                this.$store.dispatch('clearErrorField', { field });
                this.getErrorsField(field);
            }
        },

        validations: {
            form: {
                type: {
                    required
                },
                ddr: {
                    required
                },
                dpa: {
                    required
                },
                semaine_amenorrhee: {
                    required
                },
                biometrie: {
                    //
                },
                annexe: {
                    //
                },
                description: {
                    //
                },

            }
        },

        mounted() {
            this.getConsultation();
            new SlimSelect({
                select: '#single',
                placeholder: 'Select a ultrasound type',

            })
        }
    }
</script>

<style scoped>
    @import url('~slim-select/dist/slimselect.min.css');
</style>